import React, { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {jwtDecode} from 'jwt-decode';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setAuthToken] = useState(() => sessionStorage.getItem('authToken')); // Token from sessionStorage
  const [userId, setUserId] = useState(null);
  const [userType, setUserType] = useState(() => sessionStorage.getItem('userType')); // userType from sessionStorage
  const [constabulary, setConstabulary] = useState(null);
  const [msiFile, setMsiFile] = useState(() => sessionStorage.getItem('msiFile'));
  const [msiUrl, setMsiUrl] = useState(() => sessionStorage.getItem('msiUrl'));
  const [macPack, setMacPack] = useState(() => sessionStorage.getItem('macPack'));
  const [androidApk, setAndroidApk] = useState(() => sessionStorage.getItem('androidApk'));
  const [groupId, setGroupId] = useState(null);
  const [android, setAndroid] = useState(null);
  const [chromeUrl, setChromeUrl] = useState(() => sessionStorage.getItem('chromeUrl'));
  const navigate = useNavigate();

  const isTokenValid = (token) => {
    if (!token) {
      return false;
    }

    try {
      const decoded = jwtDecode(token);
      const now = Date.now() / 1000;
      if (decoded.exp < now) {
        return false;
      }
      return true;
    } catch (error) {
      return false;
    }
  };

  useEffect(() => {
    if (!isTokenValid(token)) {
      logout();
    } else {
      setAuthToken(token);
      const storedUserType = sessionStorage.getItem('userType');
      if (storedUserType) {
        setUserType(storedUserType);
      }
      const storedChromeUrl = sessionStorage.getItem('chromeUrl');
      if (storedChromeUrl) {
        setChromeUrl(storedChromeUrl);
      }
    }
  }, [token]);

  const login = (t, u) => {
    if (isTokenValid(t)) {
      sessionStorage.setItem('authToken', t);
      sessionStorage.setItem('userType', u);
      setAuthToken(t);
      setUserType(u);
    } else {
      logout();
    }
  };

  const logout = async () => {
    try {
      sessionStorage.clear();
      setAuthToken(null);
      setUserId(null);
      setUserType(null);
      setConstabulary(null);
      setMsiFile(null);
      setMsiUrl(null);
      setMacPack(null);
      setAndroidApk(null);
      setGroupId(null);
      setAndroid(null);
      setChromeUrl(null);
      navigate('/login');
    } catch (error) {
      console.error('Error logging out',);
    }
  };

  useEffect(() => {
    if (chromeUrl) {
      sessionStorage.setItem('chromeUrl', chromeUrl);
    } else {
      sessionStorage.removeItem('chromeUrl');
    }

    if (msiFile) {
      sessionStorage.setItem('msiFile', msiFile);
    } else {
      sessionStorage.removeItem('msiFile');
    }

    if (msiUrl) {
      sessionStorage.setItem('msiUrl', msiUrl);
    } else {
      sessionStorage.removeItem('msiUrl');
    }

    if (macPack) {
      sessionStorage.setItem('macPack', macPack);
    } else {
      sessionStorage.removeItem('macPack');
    }

    if (androidApk) {
      sessionStorage.setItem('androidApk', androidApk);
    } else {
      sessionStorage.removeItem('androidApk');
    }
  }, [chromeUrl, msiFile, macPack, androidApk]);

  return (
    <AuthContext.Provider
      value={{
        token,
        setAuthToken,
        userId,
        setUserId,
        login,
        logout,
        userType,
        setUserType,
        setConstabulary,
        setMsiFile,
        setMsiUrl,
        setMacPack,
        setAndroidApk,
        setGroupId,
        setAndroid,
        setChromeUrl,
        constabulary,
        msiFile,
        msiUrl,
        macPack,
        androidApk,
        groupId,
        android,
        chromeUrl,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
